<template>
  <div :class="isLeft ? 'floL' : 'floR'">
    <p
      class="fntH6 fntL bold marTML marBM"
      style="color:#2c2c2c;"
      :style="isLeft ? { width: '49%' } : null"
    >{{ getTextByType(participant.type, participant.type_seq) }}</p>
    <!-- 참여 여부 -->
    <div
      :class="isLeft ? 'NCACroa_cont01-1' : 'NCACroa_cont01-2'"
      class="padBM"
    >
      <p
        :class="isLeft ? null : 'moOnly'"
        class="fntP"
      >참여여부 <span class="ico-must-astar"></span></p>
      
      <div class="amway-theme" style="width:55%;">
        <div class="action NCACroa_radioBtn radio-wrapper NCACroa_cont01_radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :name="`attendance-radio-${seq}`"
              class="amw-global-radio"
              value="Y"
              @change="selectAttendance"
              :checked="participant.attendance_yn === 'Y'"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">참여</span>
          </label>
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              :name="`attendance-radio-${seq}`"
              class="amw-global-radio"
              value="N"
              @change="selectAttendance"
              :checked="participant.attendance_yn === 'N'"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">불참</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 이름 -->
    <div
      :class="isLeft ? 'NCACroa_cont01-1' : 'NCACroa_cont01-2'"
      class="padBSM padTSM NCACroa_cont01_input"
    >
      <label
        :for="`NCACroa_name${seq}`"
        class="fntP"
        :class="isLeft ? null : 'moOnly'"
      >이름 <span class="ico-must-astar"></span></label>
      <input
        type="text"
        :id="`NCACroa_name${seq}`"
        :name="`NCACroa_name${seq}`"
        :value="participant.name"
        @input="inputName"
        :disabled="disabledByType || disabledByAttendance"
        size="20"
      />
    </div>

    <!-- ABO 번호 -->
    <div
      :class="isLeft ? 'NCACroa_cont01-1 NCACroa_cont01_input' : 'NCACroa_cont01-2 NCACroa_pc'"
      class="padBSM padTSM"
    >
      <template v-if="isLeft">
        <label
          :for="`NCACroa_abo${seq}`"
          class="fntP"
        >ABO번호</label>
        <input
          type="text"
          :id="`NCACroa_abo${seq}`"
          :name="`NCACroa_abo${seq}`"
          :value="participant.abo_uid"
          disabled
        >
      </template>
    </div>

    <!-- 주민등록번호 -->
    <div
      :class="isLeft ? 'NCACroa_cont01-1' : 'NCACroa_cont01-2'"
      class="padBSM padTSM"
    >
      <label
        :for="`NCACroa_personal01-${seq}`"
        :class="isLeft ? null : 'moOnly'"
        class="fntP"
        style="width:45%;"
      >주민등록번호 <span class="ico-must-astar" ></span></label>
      <em class="txtR" style="width:55%;"
      ><input
        type="number"
        :id="`NCACroa_personal${seq}-1`"
        :name="`NCACroa_personal${seq}-1`" 
        class="NCACroa_num"
        style="width:45%"
        :value="participant.questions['Q003_1'].raw_data"
        @input="inputJuminNumber('Q003_1', $event.target)"
        maxlength="6"
        :disabled="disabledByAttendance"
      /><span class="disIb txtC" style="width:10%;">-</span
      ><input
        type="number"
        :id="`NCACroa_personal${seq}-2`"
        :name="`NCACroa_personal${seq}-2`"
        class="NCACroa_num"
        style="width:45%; -webkit-text-security: disc;"
        :value="participant.questions['Q003_2'].raw_data"
        @input="inputJuminNumber('Q003_2', $event.target)"
        maxlength="7"
        :disabled="disabledByAttendance"
      /></em>
    </div>

    <!-- 배우자나 가족이 있는 경우에만 -->
    <template v-if="hasFamily">
      <!-- 가족관계 증명서 -->
      <SurveyAttachment
        :class="participant.type ==='E' ? 'padBL padTM NCACroa_pc02' : 'NCACroa_familyWrap'"
        :is-left="isLeft"
        :hide-btn="participant.type ==='E'"
        :block-label="participant.type ==='E'"
        :question="questions['Q001']"
        :data="participant.questions['Q001']"
        :folder-name="folderName"
        :show-alert="hasFamily"
        :disabled="disabledByAttendance"
        @upload:file="saveFileData('Q001', $event)"
        @delete:file="removeFileData('Q001')"
      >
        <template v-if="participant.type === 'E'" #inner>
          <span
            v-html="questions['Q001'].alert_text"
            class="fntE pcOnly disBl"
            style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"
          ></span>
        </template>
        <template v-if="participant.type === 'S'" #outer>
          <p
            v-html="questions['Q001'].alert_text"
            class="fntE padTS moOnly"
            style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"
          ></p>
        </template>
      </SurveyAttachment>

      <!-- 배우자 참가 신청서 -->
      <SurveyAttachment
        :class="participant.type === 'E' ? 'NCACroa_pc02' : null"
        class="padBSM padTSM"
        :is-left="isLeft"
        :hide-btn="participant.type ==='E'"
        :question="questions['Q002']"
        :data="participant.questions['Q002']"
        :folder-name="folderName"
        :disabled="disabledByAttendance"
        @upload:file="saveFileData('Q002', $event)"
        @delete:file="removeFileData('Q002')"
      />
    </template>

    <!-- 여권 사본 -->
    <SurveyAttachment
      class="padBSM padTSM"
      :is-left="isLeft"
      :question="questions['Q004']"
      :data="participant.questions['Q004']"
      :folder-name="folderName"
      :disabled="disabledByAttendance"
      @upload:file="saveFileData('Q004', $event)"
      @delete:file="removeFileData('Q004')"
    />

    <!-- 안전확인 동의서 -->
    <SurveyAttachment
      class="padBSM padTSM"
      :is-left="isLeft"
      :question="questions['Q005']"
      :data="participant.questions['Q005']"
      :folder-name="folderName"
      :disabled="disabledByAttendance"
      @upload:file="saveFileData('Q005', $event)"
      @delete:file="removeFileData('Q005')"
    />

    <!-- 초상권 확인 동의서 -->
    <SurveyAttachment
      class="padBSM padTSM"
      :is-left="isLeft"
      :question="questions['Q006']"
      :data="participant.questions['Q006']"
      :folder-name="folderName"
      :disabled="disabledByAttendance"
      @upload:file="saveFileData('Q006', $event)"
      @delete:file="removeFileData('Q006')"
    />

    <!-- 대한항공 마일리지 번호 -->
    <div
      :class="isLeft ? 'NCACroa_cont01-1' : 'NCACroa_cont01-2'"
      class="padTSM NCACroa_cont01_input"
      style="border:none;"
    >
      <label
        :for="`NCACroa_mileage${seq}`"
        :class="isLeft ? null : 'moOnly'"
        class="fntP"
      >대한항공 <br class="moOnly">마일리지 번호</label>
      <input
        type="text"
        :id="`NCACroa_mileage${seq}`"
        :name="`NCACroa_mileage${seq}`"
        :value="participant.questions['Q007'].raw_data"
        @input="inputMileage('Q007', $event.target)"
        :disabled="disabledByAttendance"
        maxlength="12"
      />
    </div>
  </div>
</template>

<script>
import SurveyAttachment from './SurveyAttachment.vue'
import { mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import { SURVEY, INFO_QUESTIONS, SET_ATTENDANCE, SET_NAME, SET_QUESTION_ANSWER, CLEAR_RESPONSE_DATA } from '@/store/actions/survey'

export default {
  name: 'SurveyParticipant',
  mixins: [CommonMethodMixin],
  components: {
    SurveyAttachment,
  },
  props: {
    seq: {
      type: Number,
      required: true
    },
    participant: {
      type: Object,
      required: true
    },
    hasFamily: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(SURVEY, {
      questions: INFO_QUESTIONS
    }),
    isLeft() {
      return this.seq % 2 === 0;
    },
    disabledByType() {
      return this.participant.type === 'E' || this.participant.type === 'P';
    },
    disabledByAttendance() {
      return !this.participant.attendance_yn || this.participant.attendance_yn === 'N';
    },
    folderName() {
      return this.getTextByType(this.participant.type, this.participant.type_seq, 'en');
    }
  },
  methods: {
    selectAttendance(e) {
      const attendance_yn = e.target.value;
      this.$store.commit(`${SURVEY}/${SET_ATTENDANCE}`, { idx: this.seq, attendance_yn });
      if(attendance_yn === 'N') {
        this.$store.dispatch(`${SURVEY}/${CLEAR_RESPONSE_DATA}`, this.seq);
      }
    },
    inputName(e) {
      this.$store.commit(`${SURVEY}/${SET_NAME}`, { idx: this.seq, name: e.target.value })
    },
    inputJuminNumber(sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = raw_data.length !== maxLength;
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, { idx: this.seq, sq_code, raw_data, hasError });
    },
    inputMileage(sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, { idx: this.seq, sq_code, raw_data });
    },
    saveFileData(sq_code, { original_name, path }) {
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, {
        idx: this.seq,
        sq_code,
        original_name,
        path,
        hasError: !original_name || !path
      });
    },
    removeFileData(sq_code) {
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, {
        idx: this.seq,
        sq_code,
        original_name: null,
        path: null,
        hasError: false
      })
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyParticipant.vue